import React from 'react';
import { InView } from 'react-intersection-observer';
import type { CurrentCampaign } from '../../types';
import { ProductHeader } from './product-header';

export const ProductPageHeader: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IProductPageHeaderProps>>
> = props => {
  const { setHeaderVisible, isHeaderVisible, currentCampaign } = props;

  const onHeaderVisibilityChange = (isVisible: boolean) => {
    if (isHeaderVisible !== isVisible) {
      setHeaderVisible(isVisible);
    }
  };

  return (
    <InView onChange={onHeaderVisibilityChange}>
      <ProductHeader currentCampaign={currentCampaign} />
    </InView>
  );
};

interface IProductPageHeaderProps {
  isHeaderVisible: boolean;
  setHeaderVisible: React.Dispatch<React.SetStateAction<boolean>>;
  currentCampaign: CurrentCampaign;
}
